<script>
export default {
  name: 'RefreshSearchBtn',
  methods: {
    refreshSearch() {
      this.$emit('refresh-search');
    },
    onRefreshSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {...this.customQuery, searchToken: this.getSearchToken()}
      })
    },
  }
}
</script>
<template>
  <b-button variant="primary" @click="refreshSearch">検索を再表示</b-button>
</template>
